<script>
    import { createEventDispatcher } from 'svelte'; // Import the event dispatcher
    import { t } from 'svelte-i18n';

    export let newBanco;
    export let currentBancoId;
    export let isPaneOpen;
    export let togglePane;
    export let saveBancoEntry;

    let activeTab = 'detalle';
    let errors = { descrip: '' }; // Object to hold validation errors

    const dispatch = createEventDispatcher();

    $: if (!isPaneOpen) {
        activeTab = 'detalle';
        resetErrors(); // Reset errors when pane closes
    }

    function handleInput() {
        // Emit an event to the parent component
        dispatch('inputChange');
    }

    function resetErrors() {
        errors = { descrip: '' }; // Reset errors
    }

    function validateFields() {
        let valid = true;
        // Validate the 'descrip' field
        if (!newBanco.descrip.trim()) {
            errors.descrip = 'La descripción es requerida.';
            valid = false; // Set valid to false if validation fails
        } else {
            errors.descrip = ''; // Clear error if validation passes
        }
        return valid; // Return the validation result
    }

    function handleSave() {
        // Validate before saving
        if (validateFields()) {
            saveBancoEntry(); // Call the save function if validation passes
        }
    }
</script>

{#if isPaneOpen}
    <div class="pane open">
        <div class="p-4">
            <h2 class="text-xl font-bold">{currentBancoId ? $t('crudPane.editTitle', { title: $t('entities.bancos') }) : $t('crudPane.createTitle', { title: $t('entities.bancos') })}</h2>
            <!-- Pestañas -->
            <div class="flex space-x-4 mb-4">
                <button on:click={() => (activeTab = 'detalle')} class="px-4 py-2 border-b-2" class:font-bold={activeTab === 'detalle'}>
                    Detalle
                </button>
                <button on:click={() => (activeTab = 'permisos')} class="px-4 py-2 border-b-2" class:font-bold={activeTab === 'permisos'}>
                    Permisos
                </button>
            </div>
            <!-- Contenido de Detalle -->
            {#if activeTab === 'detalle'}
                <input type="text" placeholder={$t('fields.description')} bind:value={newBanco.descrip} on:input={handleInput} class="mt-2 p-2 border rounded w-full"/>
                {#if errors.descrip}
                    <p class="text-red-500 text-sm">{errors.descrip}</p> <!-- Display error message -->
                {/if}
                <div class="mt-2 flex items-center">
                    <input type="checkbox" bind:checked={newBanco.sta} id="estado-checkbox" class="mr-2" on:change={handleInput} />
                    <label for="estado-checkbox" class="text-sm">Estado</label>
                </div>
            {/if}
            <!-- Contenido de Permisos -->
            {#if activeTab === 'permisos'}
                <div class="text-gray-600">Aquí puedes gestionar los permisos (aún vacío).</div>
            {/if}
            <button on:click={handleSave} class="mt-4 px-4 py-2 bg-blueGray-600 text-white rounded hover:bg-indigo-600">
                {currentBancoId ? 'Actualizar' : 'Crear'}
            </button>
            <button on:click={togglePane} class="mt-4 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600">Cerrar</button>
        </div>
    </div>
{/if}
